import React from 'react'
import { AnyFunction, useBooleanToggle, useI18N } from '@codeleap/common'
import { View, Button, Modal } from '@/components'
import { I18NDictionary } from '@/app/i18n'
import { Link, useI18next } from 'gatsby-plugin-react-i18next'
import { assignTextStyle, variantProvider } from '@/app'

const languageOptions = Object.entries(I18NDictionary).map(([key, value]) => ({
  label: value.__LABEL,
  value: key,
}))

type LanguageSelectorProps = {
  path?: string
  onPress?: AnyFunction
}

const _Link = (props) => <Link {...props} style={styles.link} />

export const LanguageSelector = ({ onPress }: LanguageSelectorProps) => {
  const [visible, toggle] = useBooleanToggle(false)

  const { locale, t, setLocale } = useI18N()
  const { originalPath } = useI18next()

  return <>
    <View variants={['column', 'gap:2']}>
      <Button
        text={t('languageSelector', { language: locale })}
        onPress={() => {
          onPress?.()
          toggle()
        }}
        debugName='open language selector modal'
        variants={['outline']}
        rightIcon='languages'
      />
    </View>

    <Modal
      toggle={toggle}
      debugName='Language selector'
      variants={['centered', 'box:responsiveness']}
      visible={visible}
      title='Language'
      description='Select a language'
    >
      <View variants={['gap:1', 'column']}>
        {languageOptions.map((item) => {
          return (
            <Button
              component={_Link}
              debugName='language selector'
              key={item.label}
              to={originalPath + ('')}
              variants={['link', (item.value === locale) && 'link:outline']}
              language={item.value}
              onClick={() => {
                toggle(false)
                setLocale(item?.value)
              }}
            >
              {item.label}
            </Button>
          )
        })}
      </View>
    </Modal>
  </>
}

const styles = variantProvider.createComponentStyle(theme => ({
  link: {
    textDecoration: 'none',
    ...assignTextStyle('p1')(theme).text,
    color: theme.colors.neutral10,
  }
}), true)
